import React,{ useState, useEffect } from "react";
import Product from "./Product";
import "./css/Allmen.css";
import { firestore } from '../firebase';

function AllMen () {
  const [categoryFilter, setCategoryFilter] = useState('');
  const [priceFilter, setPriceFilter] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [productIds, setProductIds] = useState([]);
  const [theProducts, setTheProducts] = useState([]);

  useEffect(() => {
    const userStoriesRef = firestore.collection('products');

    const unsubscribe = userStoriesRef.onSnapshot((querySnapshot) => {
      const ids = [];
      const userStoriesData = [];

      querySnapshot.forEach((doc) => {
        ids.push(doc.id);
        const data = doc.data();
        userStoriesData.push(data);
      });

      setProductIds(ids);
      setTheProducts(userStoriesData);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const filterProduct = () => {
      const filtered = theProducts.filter((data) => {
        const categoryMatch = (categoryFilter === '' || data?.productCategory === categoryFilter) && data?.productCategory === 'men';
  
        const priceMatch =
          priceFilter === '' ||
          (priceFilter === 'at $1 - $249' && data?.productPrice > 0 && data?.productPrice < 250) ||
          (priceFilter === 'at $250 - $499' && data?.productPrice >= 250 && data?.productPrice < 500) ||
          (priceFilter === 'at $500 - $999' && data?.productPrice >= 500 && data?.productPrice < 1000) ||
          (priceFilter === 'at $1000 and above' && data?.productPrice >= 1000);
  
        return categoryMatch && priceMatch;
      });
  
      setFilteredProducts(filtered);
    };
  
    filterProduct();
  }, [categoryFilter, priceFilter, theProducts]);
  
    return(
      <div className="all-men">
        <div className="men-header">
          <h2>Men's Clothing</h2>
        </div>

        <div className="men-products">
          <div className="men-products-row">
          {filteredProducts.length === 0 ? (
            <span style={{ textAlign: 'left', fontFamily: 'sans-serif', paddingTop: '20px', fontWeight: 'bold' }} >
              No product found.
            </span>
          ) : (
            <>
              {filteredProducts.map((data, index) => (
                <Product key={index} data={data} productId={productIds[index]} />
              ))}
            </>
          )}
          </div>
        </div>
      </div>
    )
}

export default AllMen